import { deliveryServerInstance } from "../axios/instances";
import encryptRSA from "../ssl/encrypt";
import { MESSAGE_CENTER as type } from "./messageCenterTypes";

export function getMessageTypes() {   
    return function(dispatch) {
        dispatch({type: type.GET_MESSAGE_TYPES})
        return deliveryServerInstance.get(`/messages/types/UMMN`)
        .then(({data}) => {
            dispatch({
                type: type.GET_MESSAGE_TYPES_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_MESSAGE_TYPES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getRecipientGroup() {   
    return function(dispatch) {
        dispatch({type: type.GET_RECIPIENT_GROUP})
        return deliveryServerInstance.get(`/masterdata/dictionaries/MESSAGE-RECIPIENT-TYPE`)
        .then(({data}) => {
            dispatch({
                type: type.GET_RECIPIENT_GROUP_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_RECIPIENT_GROUP_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDisableOption() {   
    return function(dispatch) {
        dispatch({type: type.GET_DISABLE_OPTION})
        return deliveryServerInstance.get(`/masterdata/dictionaries/MESSAGE-PROMPT-OPTION`)
        .then(({data}) => {
            dispatch({
                type: type.GET_DISABLE_OPTION_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_DISABLE_OPTION_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getRecipientsAll(warehouse) {   
    return function(dispatch) {
        dispatch({type: type.GET_RECIPIENTS_ALL})
        return deliveryServerInstance.get(`/messages/recipients/0?warehouse=${warehouse}`)
        .then(({data}) => {
            dispatch({
                type: type.GET_RECIPIENTS_ALL_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_RECIPIENTS_ALL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getRecipients(recipientType, warehouse) {   
    return function(dispatch) {
        dispatch({type: type.GET_RECIPIENTS})
        return deliveryServerInstance.get(`/messages/recipients/${recipientType}?warehouse=${warehouse}`)
        .then(({data}) => {
            dispatch({
                type: type.GET_RECIPIENTS_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_RECIPIENTS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {Number} params.warehouse
 */
export function getDrafts(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_DRAFTS})
        return deliveryServerInstance.get(`/messages/drafts/${params.warehouse}`, {
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, params.warehouse)
            }
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_DRAFTS_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_DRAFTS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {Number} params.warehouse
 * @param {string} params.posted_from
 * @param {string} params.posted_to
 * @param {Number} params.type_code
 * @param {Number} params.recipient_type
 * @param {string} params.recipient
 * @param {string} params.title
 */
export function getMessagesHistory(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_MESSAGES_GENERAL_HISTORY})
        return deliveryServerInstance.get(`/messages/general/history`, {
            params: params,
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, params.warehouse)
            }
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_MESSAGES_GENERAL_HISTORY_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_MESSAGES_GENERAL_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {Number} params.warehouse
 * @param {string} params.posted_from
 * @param {string} params.posted_to
 * @param {Number} params.type_code
 * @param {Number} params.recipient_type
 * @param {string} params.recipient
 * @param {string} params.title
 */
export function getMessagesGeneral(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_MESSAGES_GENERAL})
        return deliveryServerInstance.get(`/messages/general`, {
            params: params,
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, params.warehouse)
            }
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_MESSAGES_GENERAL_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_MESSAGES_GENERAL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDrivers(id) {   
    return function(dispatch) {
        dispatch({type: type.GET_DRIVERS})
        return deliveryServerInstance.get(`/messages/recipients/unread/${id}`)
        .then(({data}) => {
            dispatch({
                type: type.GET_DRIVERS_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_DRIVERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getQuantities(id) {   
    return function(dispatch) {
        dispatch({type: type.GET_RATIO})
        return deliveryServerInstance.get(`/messages/recipients/quantities/${id}`)
        .then(({data}) => {
            dispatch({
                type: type.GET_RATIO_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.GET_RATIO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function deleteMessage(id, params) {   
    return function(dispatch) {
        dispatch({type: type.DELETE_MESSAGE})
        return deliveryServerInstance.delete(`/messages/${id}`, {
            params: params,
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, params.warehouse)
            }
        })
        .then(({data}) => {
            dispatch({
                type: type.DELETE_MESSAGE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.DELETE_MESSAGE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {Number} params.message_type
 * @param {string} params.effective_from
 * @param {string} params.effective_to
 * @param {Number} params.recipient_type
 * @param {Array} params.recipient
 * @param {Number} params.prompts_mode
 * @param {string} params.title
 * @param {string} params.content
 */
export function editMessage(id, params, warehouse) {   
    return function(dispatch) {
        dispatch({type: type.EDIT_MESSAGE})
        return deliveryServerInstance.put(`/messages/${id}`, params,
        {
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, warehouse)
            }
        })
        .then(({data}) => {
            dispatch({
                type: type.EDIT_MESSAGE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.EDIT_MESSAGE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {Number} params.message_type
 * @param {string} params.effective_from
 * @param {string} params.effective_to
 * @param {Number} params.recipient_type
 * @param {Array} params.recipient
 * @param {Number} params.prompts_mode
 * @param {string} params.title
 * @param {string} params.content
 * @param {Number} params.warehouse_id
 * @param {string} params.creator
 */
export function createMessage(params) {   
    return function(dispatch) {
        dispatch({type: type.CREATE_MESSAGE})
        return deliveryServerInstance.post(`/messages`, params, {
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, params.warehouse_id)
            }
        })
        .then(({data}) => {
            dispatch({
                type: type.CREATE_MESSAGE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: type.CREATE_MESSAGE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}